"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// utils

/* ++++++++++ --------------- BUTTON : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'Feedback',
  group: _definitionhelpers.groupNames.ctas,
  props: {
    disabled: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    position: {
      type: 'string',
      default: 'right',
      options: ['left', 'right']
    },
    handleClick: {
      type: 'function',
      default: function _default() {
        return console.log("clicked!");
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    }
  }
};
exports.default = _default2;